import { FETCH_SHIPPING_LABEL, LABEL_LOADING, UNSHIP_LOADING, NOTIFY_LOADING } from '../actions/types'

const initialState = {
  new_label: {},
  labelLoading: false,
  unshipLoading: false,
  notifyLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPPING_LABEL:
      return { ...state, new_label: action.payload }
    case LABEL_LOADING:
      return { ...state, labelLoading: action.payload }
    case UNSHIP_LOADING:
      return { ...state, unshipLoading: action.payload }
    case NOTIFY_LOADING:
      return { ...state, notifyLoading: action.payload }
    default:
      return state
  }
}
